// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Select_checkbox__1iwOI","checked":"Select_checked__3yxhx"};